exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove-button[data-v-ac872fb0] {\n  cursor: pointer;\n  display: none;\n}\n.card:hover .remove-button[data-v-ac872fb0] {\n  display: block;\n}\n.lecture-tag[data-v-ac872fb0] {\n  position: absolute;\n  top: 0;\n  right: 10px;\n  color: #fff;\n  padding: 0 5px;\n  border-radius: 0 0 5px 5px;\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 75%;\n}\n.lecture-tag-pay[data-v-ac872fb0] {\n  background-color: #e91e63;\n}\n.pos-tr[data-v-ac872fb0] {\n  top: 5px;\n  left: 5px;\n}\n.views-number[data-v-ac872fb0] {\n  min-width: 4.5rem;\n  text-align: right;\n}", ""]);

// exports
